import { useTranscriptionsState } from '@modules/transcriptions/useTranscriptionsState';
import { Stack, Tooltip, Typography } from '@mui/material';
import { IChatSession } from 'src/@types/chat';
import { Note } from 'src/@types/notes-transcription';
import { Iconify } from 'src/components/iconify';
import { useActionBarState } from 'src/features/ActionsBar/useActionBarState';
import { PastSessionItemHeader } from 'src/features/GatheringSessions/PastSessionItemHeader';
import { useLocales } from 'src/locales';
import { SessionItemContent, SessionMenuItem, StyledNoteItem } from './styles';

interface IProps {
  session: IChatSession;
  channelId: string;
  handleClose: () => void;
}

export const PastSessionsItem = ({ session, handleClose }: IProps) => {
  const { translate } = useLocales();

  const { openNote } = useTranscriptionsState();
  const { setOpenAction } = useActionBarState();

  const handleOpenNote = (note: Note) => {
    openNote(note);
    setOpenAction('notes');
    handleClose();
  };

  return (
    <SessionMenuItem>
      <PastSessionItemHeader session={session} handleClose={handleClose} />

      {!!session?.transcriptions?.length && (
        <SessionItemContent>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2" color="text.secondary">
              {translate('communicate.transcriptions')}
            </Typography>
          </Stack>

          {session?.transcriptions?.map((note) => (
            <StyledNoteItem key={note._id} onClick={() => handleOpenNote(note)}>
              <Stack direction="row" alignItems="center" gap={0.5}>
                <Iconify icon="tabler:file-text" color="primary.main" />
                <Typography variant="subtitle2">{note.title}</Typography>
              </Stack>
              {!note.noteRef && (
                <Tooltip title={translate('communicate.transcriptions.empty')}>
                  <Iconify
                    icon="tabler:alert-triangle"
                    color="error.main"
                    width={16}
                  />
                </Tooltip>
              )}
            </StyledNoteItem>
          ))}
        </SessionItemContent>
      )}
    </SessionMenuItem>
  );
};
